module.exports = __webpack_public_path__ + "static/media/02n.05ef0672.png";